<template>
  <v-card>
    <v-card-title class="headline">
      <strong class="headline"
        >Adição de previsão do orçamento (Tratamento)
      </strong>
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-0">
      <v-container class="px-3 pt-2 pb-0">
        <v-layout row wrap justify-center class="mt-2">
          <v-flex>
            <v-text-field
              box
              hide-details
              step="0.01"
              type="number"
              label="Tratamento"
              v-model="orcamento_tratamento"
            />
          </v-flex>
          <v-flex xs12 class="mt-4">
            <h4 class="subheading">Dividir entre os dias:</h4>
          </v-flex>
          <v-flex xs12>
            <v-date-picker
              multiple
              no-title
              full-width
              :min="min"
              :max="max"
              locale="br"
              prev-icon=""
              next-icon=""
              class="elevation-0 qj-date-picker"
              v-model="dates"
            ></v-date-picker>
          </v-flex>
          <v-flex xs12 style="display: flex; margin-top: 1rem">
            <v-spacer />
            <v-btn
              flat
              small
              class="ma-0"
              @click="all_days"
              color="pink accent-2"
            >
              Incluir todos os dias
            </v-btn>
            <v-btn
              flat
              small
              class="ma-0"
              @click="dates = []"
              color="pink accent-2"
            >
              Limpar dias
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider />
    <v-card-actions class="py-2">
      <v-btn flat color="primary accent-2" @click="closeDialog">Cancelar</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="gerar_orcamento" :disabled="esperar"
        >Salvar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: [
    "open",
    "ano_mes",
    "esperar",
    "total_higienizacao",
    "total_gasto_mes",
    "nome_credor",
  ],
  data() {
    return {
      dates: [],
      orcamento_tratamento: "",
      orcamento_tratamento: "",
    };
  },
  computed: {
    min() {
      let min = this.ano_mes[0] + "-";
      if (this.ano_mes[1] > 10) min += "0" + this.ano_mes[1];
      else min += this.ano_mes[1];
      min += "-0" + 1;
      return min;
    },
    max() {
      let max = this.ano_mes[0] + "-";
      if (this.ano_mes[1] > 12) max += "0" + this.ano_mes[1];
      else max += this.ano_mes[1];
      max += "-" + this.dias_mes;
      return max;
    },
    dias_mes() {
      return new Date(this.ano_mes[0], this.ano_mes[1], "0").getDate();
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.dates = [];

      }
    },
    ano_mes: function (novo, velho) {
      this.estado_inicial();
    },
    nome_credor: function (novo, velho) {
      this.estado_inicial();
    },
  },
  methods: {
    estado_inicial() {
      this.orcamento_tratamento = "";
      this.orcamento_tratamento = "";
    },
    gerar_orcamento() {
      const lista_mes = this.gerar_dias();
      const recursos_dia = (
        parseFloat(this.orcamento_tratamento) / lista_mes.length
      ).toFixed(2);

      if (isNaN(this.orcamento_tratamento)) {
        this.$store.commit(
          "showSnackbar",
          "verifique seus dados, valores inválidos!"
        );
      } else {
        lista_mes.map((d) => {
          d.budget = recursos_dia;
        });

        this.$emit("salvar", lista_mes);
        this.estado_inicial();
      }
    },
    gerar_dias() {
      var lista = [];
      var dia_considerado = new Date(
        this.ano_mes[0],
        this.ano_mes[1] - 1,
        this.dates[0].split("-")[2]
      );

      this.dates.forEach((date) => {
        lista.push({
          dia_semana: dia_considerado.getDay(),
          dia: date.split("-")[2],
          goal: 0,
          budget: 0,
        });
        dia_considerado.setDate(dia_considerado.getDate() + 1);
      });

      return lista;
    },
    closeDialog() {
      this.$emit("closeDialog");
      this.estado_inicial();
    },
    all_days() {
      let anoMes = this.ano_mes.join("-") + "-";
      let newDates = [];
      for (let dia = 1; dia <= this.dias_mes; dia++) {
        newDates.push(anoMes + (dia < 10 ? "0" + dia : dia));
      }
      this.dates = newDates;
    },
  },
};
</script>

<style>
.qj-date-picker td {
  padding: 0;
}
</style>
